// extracted by mini-css-extract-plugin
export var redoItem = "_nc-1";
export var redoTrigger = "_nc-0";